import React, { Component } from 'react';
import { FormattedMessage } from 'ui/i18n';
import { PageHeader } from 'ui/components';
import { authorize } from 'utils/auth';

@authorize({ rights: ['GetSalesReport'] })
export default class OrderStatusReports extends Component {
	render() {
		return (
			<div>
				<PageHeader
					id="orderStatus-page-header"
					headerText={
						<span>
							<FormattedMessage id="navigation.salesReports" />
						</span>
					}
				/>
				<div className="OrderStatus" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/pages/SalesReports/index.js